export default __webpack_public_path__ + "static/media/Badge.d3dd4a96.svg";